import fetch from '@/utils/fetch'

// 登录
export const login = ({ email, password }) =>
  fetch('/a/auth/login', {
    email,
    password,
  })

// 获取个人信息
export const userInfo = () => fetch('/a/admin/me')

// 注销
export const logout = () => fetch('/a/auth/logout')

// 我的菜单
export const apiMyMenus = () => fetch('/a/admin/myMenus')
